var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule"},[_c('img',{attrs:{"src":"https://oss.mcloud.moveclub.cn/alphamovecloud/20230823/1692776405/834634.png","alt":""}})])}]

export { render, staticRenderFns }